// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import { 
  Card, Grid
} from "@mui/material";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKBadge from "components/MKBadge";

function BlogPostCard({ title, subtitle, tags, color, image, url, children, ...rest }) {
  return (
    <Card onClick={() => { if (url) window.location.href = url; }} sx={{ mt: 3, cursor: url ? 'pointer' : 'default' }}>
      <Grid container>
        {image ? (
          <Grid item xs={12} md={6}>
            <MKBox width="100%" pt={2} pb={1} px={2} justifyContent="center" textAlign="center">
              <MKBox
                component="img"
                src={image}
                alt={name}
                width="100%"
                maxHeight="400px"
                borderRadius="md"
                shadow="lg"
              />
            </MKBox>
          </Grid>
        ) : null}
        <Grid item xs={12} md={image ? 6 : 12} sx={{ my: "auto" }}>
          <MKBox pt={{ xs: 3, lg: 4 }} pb={2.5} pr={4} pl={{ xs: 4, lg: 1 }} lineHeight={1}>
            <MKBox display="flex" alignItems="center" justifyContent="space-between" mb={1} lineHeight={1}>
              <MKTypography variant="h5">
                {title}
              </MKTypography>
            </MKBox>
            <MKTypography variant="h6" color={color} mb={1}>
              {subtitle}
            </MKTypography>
            <MKBox mb={2}>
              {tags.map((tag) => {
                return (
                  <MKBadge key={tag} badgeContent={tag} color={"primary"} container />
                )
              })}
            </MKBox>
          </MKBox>
        </Grid>
      </Grid>
    </Card>
  );
}

// Typechecking props for the FaqCollapse
BlogPostCard.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
  color: PropTypes.string,
  url: PropTypes.string,
  image: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default BlogPostCard;